import Collection from './Collection'
import { Routes, Route, Link, Navigate, useLocation } from 'react-router-dom'
import Payment from './Payment'
import Due from './Due'

const Reports = () => {
    return (
        <div className="container mx-5">
            <div className="row">
                <div className="col-2 col-md-2 border-end border-1" align="left">
                    <h4 className="text-muted my-4">Reports</h4>
                    <ul className='list-group list-group-flush'>
                        <li className="list-group-item list-group-item-light"><Link className="text-decoration-none text-app" to="collection">Collection Report</Link></li>
                        <li className="list-group-item list-group-item-light"><Link className="text-decoration-none text-muted" to="payment">Payment Report</Link></li>
                        <li className="list-group-item list-group-item-light"><Link className="text-decoration-none text-muted" to="due">Due Report</Link></li>
                    </ul>
                </div>
                <div className="col-10 col-md-10">
                    <Routes>
                        <Route path="/" element={<Navigate to="collection" replace />} />
                        <Route path="collection" element={<Collection />} />
                        <Route path="payment" element={<Payment />} />
                        <Route path="due" element={<Due />} />
                    </Routes>
                </div>
            </div>
        </div>
    )
}

export default Reports;